import React from "react"
import { useState, useContext, useCallback } from "react"
import DodoneContext from 'app/dodones/Context'
import SpinnableButton from 'app/components/buttons/Spinnable'

export default ({ text = "Done", attributes = {} }) => {
  const { finishDodone, updateDodone } = useContext(DodoneContext)
  const [isConfirmed, setIsConfimed] = useState(false)

  const onFinish = useCallback(() => {
    if(!isConfirmed) {
      setIsConfimed(true)
      return;
    }

    finishDodone(attributes)
  })

  return <div className="input-group">
           <SpinnableButton className="btn btn-success btn-block" onClick={ onFinish } isSpinning={ updateDodone.isPending }>
             {
               isConfirmed ? 'Are you sure?' : text
             }
           </SpinnableButton>
         </div>
}
